import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import SettingsSidebar from './SettingsSidebar/SettingsSidebar';
import CompanyInformation from './CompanyInformation/CompanyInformation';
import ApplicationSettings from './ApplicationSettings/ApplicationSettings';
import NotificationSettings from './NotificationSettings/NotificationSettings';
import SecuritySettings from './SecuritySettings/SecuritySettings';
import BrandingSettings from './BrandingSettings/BrandingSettings';
import ManagementSettings from './ManagementSettings/ManagementSettings';
import BuildingManagersSettings from './BuildingManagersSettings/BuildingManagersSettings';
import ContractorsSettings from './ContractorsSettings/ContractorsSettings';
import QuickViewSettings from './QuickViewSettings/QuickViewSettings';
import MainHeader from '../../shared/MainHeader/MainHeader';
import './Settings.css';
import './settings-shared.css';

function Settings() {
  const location = useLocation();
  const isStandalone = !location.pathname.match(/\/(propertydashboard|properties)\/\d+\/settings/);

  const content = (
    <div className={`settings-layout ${isStandalone ? 'settings-standalone' : ''}`}>
      <div className="settings-container">
        <SettingsSidebar />
        <main className="settings-content">
          <Routes>
            <Route index element={<Navigate to="company" replace />} />
            <Route path="company" element={<CompanyInformation />} />
            <Route path="application" element={<ApplicationSettings />} />
            <Route path="notifications" element={<NotificationSettings />} />
            <Route path="security" element={<SecuritySettings />} />
            <Route path="branding" element={<BrandingSettings />} />
            <Route path="management" element={<ManagementSettings />} />
            <Route path="building-managers" element={<BuildingManagersSettings />} />
            <Route path="contractors" element={<ContractorsSettings />} />
            <Route path="quick-view" element={<QuickViewSettings />} />
          </Routes>
        </main>
      </div>
    </div>
  );

  if (isStandalone) {
    return (
      <div className="settings-page">
        <MainHeader />
        {content}
      </div>
    );
  }

  return content;
}

export default Settings;
